import { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Grid } from "@mui/material";
import BreadCrumb from "../../../../components/navbar/Breadcrumb";
import { ordenarProvinciasYMunicipios } from "../../../../functions/ordenarListas";
import { verificarTelefono } from "../../../../functions/validator/formValidator";
import { createAlmacen } from "../../../../services";
import { withRouter } from "../../../../providers/withRouter";
import { useNavigate } from "react-router-dom";
import provinces from "@doncicuto/es-provinces";
import municipalities from "@doncicuto/es-municipalities";

const NuevoAlmacen = () => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();

  const [almacen, setAlmacen] = useState({});
  const [listadoMunicipios, setListadoMunicipios] = useState([]);

  const seleccionarMunicipios = (e) => {
    let provincia = "";
    let municipios = [];
    provinces.map(p => {
      if (p.code === e.target.value) {
        provincia = p.name;
      }
    });

    setAlmacen({
      ...almacen,
      provincia,
    });

    municipalities.map(m => {
      if (m.provCode === e.target.value) {
        municipios.push(m);
      }
    });
    setListadoMunicipios(municipios);
  };

  function handleSubmit(data) {
    const toastInfo = toast.info(t('almacenes.messages.saving'));
    let telefonoCorrecto = verificarTelefono(data.telefono);
    let errores = false;

    if (Object.keys(data).length === 0) {
      toast.update(toastInfo, {
        render: t('almacenes.messages.emptyAlmacen'),
        type: toast.TYPE.ERROR,
        autoClose: true,
      });
      errores = true;
    } else {
      if (telefonoCorrecto === false && data.telefono != undefined) {
        toast.dismiss(toastInfo);
        toast.error(t('almacenes.messages.incorrectPhone'));
        errores = true;
      }

      const requiredFields = ['nombre'];

      requiredFields.forEach((field) => {
          if (!data[field]) {
              toast.error(t('almacenes.messages.fieldRequired', { field }));
              errores = true;
          }
      });


    }
    if (!errores) {
      createAlmacen(data)
        .then((res) => {
          const mensaje = res.data
          console.log(mensaje)
          if (res.status === 201) {
            toast.update(toastInfo, {
              render: mensaje.msg,
              type: toast.TYPE.SUCCESS,
              autoClose: true,
            });
           navigate("/almacenes");
          }
          else if(res.status === 400){
            toast.update(toastInfo, {
              render: mensaje.msg,
              type: toast.TYPE.ERROR,
              autoClose: true,
            });
          }
          else if (res.status === 403) {
            toast.update(toastInfo, {
              render: t('messages.error'),
              type: toast.TYPE.ERROR,
              autoClose: true,
            });
          } else {
            toast.update(toastInfo, {
              render: t('almacenes.messages.unknownError'),
              type: toast.TYPE.ERROR,
              autoClose: true,
            });
          }
        })
        .catch((err) => {
          console.log("ERROR", err);
          toast.error(t('almacenes.messages.createError'));
        });
    }
  }

  function handleChange(evt) {
    const value = evt.target.value;
    setAlmacen({
      ...almacen,
      [evt.target.name]: value,
    });
  }

  return (
    <>
      <BreadCrumb rutas={[{ path: '/almacenes', label: t('almacenes.title') }, { path: '/almacenes', label: t('almacenes.new') }]} style={{ margin: '0 10px' }} />
      <div className="pageContent">
        <div className="gridHead">
          {t('almacenes.createNew')}
        </div>
        <form className="nuevoAAFFForm">
          <Grid
            container
            spacing={5}
            style={{ marginTop: 20, marginBottom: 20, padding: '0 20px' }}
          >
            <Grid item xs={12} sm={6}>
              <input
                type="text"
                required
                placeholder={t('form.firstName')}
                name="nombre"
                value={almacen.nombre}
                onChange={handleChange}
              ></input>
            </Grid>
            <Grid item xs={12} sm={6}>
              <input
                type="tel"
                required
                placeholder={t('form.phone')}
                name="telefono"
                value={almacen.telefono}
                onChange={handleChange}
              ></input>
            </Grid>
            <Grid item xs={12} sm={6}>
              <select
                required
                name="provincia"
                onChange={(e) => seleccionarMunicipios(e)}
              >
                <option value={almacen.provincia}>{t('form.province')}</option>
                {provinces.sort(ordenarProvinciasYMunicipios)?.map((e, i) => {
                  return (
                    <option key={i} value={e.code}>
                      {e.name}
                    </option>
                  );
                })}
              </select>
            </Grid>
            <Grid item xs={12} sm={6}>
              <select
                name="municipio"
                onChange={handleChange}
              >
                <option value={almacen.municipio}>{t('common:filters.municipality')}</option>
                {listadoMunicipios.sort(ordenarProvinciasYMunicipios)?.map((e, i) => {
                  return (
                    <option key={i} value={e.value}>
                      {e.name}
                    </option>
                  );
                })}
              </select>
            </Grid>
            <Grid item xs={12} sm={6}>
              <input
                type="text"
                placeholder={t('common:form.address')}
                name="direccion"
                value={almacen.direccion}
                onChange={handleChange}
              ></input>
            </Grid>
          </Grid>
          <Grid style={{ display: 'flex', justifyContent: 'end', padding: 20 }}>
            <input
              type="button"
              value={t('actions.save')}
              onClick={() => handleSubmit(almacen)}
            ></input>
          </Grid>
        </form>
      </div>
    </>
  );
};

export default withRouter(NuevoAlmacen);
